'use strict';

angular.module('buyers')
.directive('openHomeRegistration', ['$rootScope', 'BuyerService', function($rootScope, BuyerService) {
    return {
        templateUrl : "partials/open-home-registration.html",
        restrict: 'E', // attribute
        scope: {
            'back': '&onBack',
            'openHome':'=',
        },
        link : function (scope, element, attrs) {
            var currentUser = $rootScope.currentUser;
            scope.registration = {
                name: currentUser.name,
                email: currentUser.info.email,
                phone: currentUser.info.mobile,
            };
            
            element.find('.register').on('click', function(){
                $rootScope.loading = true;
                BuyerService.registerForOpenHome(scope.registration, scope.openHome)
                .then(function(data){
                    alert('You have been registered for open home.');
                })
                .catch(function(err){
                    console.log(err);
                })
                .finally(function(data){
                    $rootScope.loading = false;
                });
            });
        }
    };
}]);